module.exports = __webpack_public_path__ + "static/media/ProductSearch_002.fe775108.png";